"use strict";

var Handlebars = require("handlebars/runtime");
require("./trans-helper");
require("./locale-helper");
require("./url-helper");
require("./iterate-range-helper");

module.exports = Handlebars;
